import { deliverySelector } from "../delivery/selectors";
import { DELIVERY_ADDRESS, DELIVERY_PICKUP } from "../delivery/reducer";
import {
  isNowBetweenWorkingHoursSelector,
  storeSelector,
} from "../store/selectors";
import { totalCartProducts } from "../cart/selectors";
import { menuReadySelector } from "../products/selectors";

export const CHECKOUT_BLOCK_REASONS = {
  MENU_UNAVAILABLE: "menu_unavailable",
  STORE_CLOSED: "store_closed",
  DELIVERY_TYPE_REQUIRED: "delivery_type_required",
  ADDRESS_REQUIRED: "address_required",
  PICKUP_LOCATION_REQUIRED: "pickup_location_required",
  MIN_ORDER_VALUE: "min_order_value",
};

export function getCheckoutBlockReason({
  workingHours,
  delivery,
  minOrderValue,
  cartTotal,
  menuReady,
  deliveryTypes,
  pickupLocations,
}) {
  if (!menuReady) return CHECKOUT_BLOCK_REASONS.MENU_UNAVAILABLE;
  if (!workingHours) {
    return CHECKOUT_BLOCK_REASONS.STORE_CLOSED;
  }
  if (!delivery.type || !deliveryTypes.includes(delivery.type)) {
    return CHECKOUT_BLOCK_REASONS.DELIVERY_TYPE_REQUIRED;
  }
  if (
    delivery.type === DELIVERY_ADDRESS &&
    (!delivery.address ||
      typeof delivery.cost !== "number" ||
      !Number.isFinite(delivery.cost) ||
      delivery.cost < 0)
  ) {
    return CHECKOUT_BLOCK_REASONS.ADDRESS_REQUIRED;
  }
  if (
    delivery.type === DELIVERY_PICKUP &&
    !pickupLocations.some(
      (location) => String(location.id) === String(delivery.pickup_location_id)
    )
  ) {
    return CHECKOUT_BLOCK_REASONS.PICKUP_LOCATION_REQUIRED;
  }
  if (
    delivery.type === DELIVERY_ADDRESS &&
    minOrderValue !== null &&
    cartTotal < minOrderValue
  ) {
    return CHECKOUT_BLOCK_REASONS.MIN_ORDER_VALUE;
  }

  return null;
}

export const checkoutBlockReasonSelector = (state) => {
  const store = storeSelector(state);
  return getCheckoutBlockReason({
    workingHours: isNowBetweenWorkingHoursSelector(state),
    delivery: deliverySelector(state),
    minOrderValue: store.minOrderValue,
    cartTotal: totalCartProducts(state),
    menuReady: menuReadySelector(state),
    deliveryTypes: store.deliveryTypes,
    pickupLocations: store.pickupLocations,
  });
};

export const canCheckoutSelector = (state) =>
  checkoutBlockReasonSelector(state) === null;
